import {
  getManagerBusinessCount,
  getStoreList,
  getStaffDetail,
  getMessageList,
  getIntegratedAnalysis,
  getPerformanceAnalysis,
  getOrderPeriodAnalysis,
  changeStore,
  readMessageInfo,
  updateMessageStatus,
  getProcessOrderList,
  getStationStaffList,
  getRolesStaffList,
  getDesigner,
  getVillageList,
  saveDesigner,
  preCustomerList,
  getAllList,
  getPreCustomerInfo,
  saveOpportunity,
  getSelectFieldOption,
  getHouseTypeList,
  getOfflineChannel,
  getHouseStatusList,
  QueryMobile,
  getOpportunityList,
  getOrderDepositInfo,
  changeToBigDeposit,
  resetReceipt,
  getStorePackageCategory,
  getStoreProductPackage,
  getOrderDetails,
  saveOrder,
  quickOrder,
  getOrderAmountInfoById,
  buildCode,
  sendAmountImage,
  authent,
  receiptAmount,
  getFollowTypeList,
  saveOpportunityFollow,
  getOrderList,
  getOrder,
  saveRefundAmount,
  getChangeItems,
  appletWeChatCode,
  getOrderStatus, getOrderDepositList,
  getBroadcastAnalysis,
  confirm,
  getDemandsList,
  customerInfo,
  getSpaceList,
  getMembers,
  getCharacterTrend,
  getMeasureInviteList,
  getMetering,
  addInvite,
  getMeasureInvite,
  determineMeasure,
  editDesigner,
  addDemandInvite,
  getDemandInviteList,
  getInviteInfo,
  delInvite,
  getOpportunityAffirmStatus,
  getOpportunityLoseReason,
  loseOpportunity,
  keyDataStatistics,
  interviewStatistics,
  keyActionStatistics,
  orderTypeStatistics,
  timeStatistics,
  managerList,
  getExplainCustomer,
  getOverStoreInfo,
  leaveNoticeMessage,
  getStoreDetail,
  getOrderInfo,
  getCustomers,
  getFollowList,
  getTodayFollowList,
  getDesignedList,
  invalidVisit,
  getOrderListContinue,
  noVisit,
  getOrderAmountList,
  getStoreManager,
  savePresaleContract,
  getFollowDetail,
  getOrderAmountInfo,
  closeAmount,
  getBaseOrderDetail,
  sendSmsCode,
  getRefundAmountInfo,
  saveApprovalInfo,
  savePresaleOrder,
  getBaseOpportunityInfo,
  getHouseInfo,
  changeToPresale,
  getCustomerList,
  savePreSale,
  getOpportunityStatus,
  getLoseReasonList,
  getMayRefundAmount,
  getOpportunityFollowHistory,
  getFollowProcessList,
  getFollowDesignerList,
  getFollowRecord,
  getFollowProcessDesignerList,
  addDesignerFollow,
  getPersonalDemand,
  getSelectOperation
} from '@/api/customerManager.js'

import { setTokenByKey, setToken, getToken } from '@/utils/auth'
import { Notify } from 'vant'
import { login } from '@/api/staff'
const staffDetailKey = 'delivery-staff_detail'

const setStaffDetail = token => setTokenByKey(token, staffDetailKey)

import { SessionStorage } from '@/utils'
import { getStaffRole } from '@/api/delivery'
const session = new SessionStorage()
// const default_token = '369f68f2-700e-4a53-b3d8-047863149961'
// setToken(default_token)

const state = {
  token: getToken(),
  staff_detail: '',
  station_type_id: 1,
  def_staff_role_id: session.get('def_staff_role_id') || '',
  staff_role_list: session.getObject('staff_role_list') || ''
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
    setToken(token)
  },
  SET_STAFF_DETAIL: (state, staff_detail) => {
    state.staff_detail = staff_detail
    setStaffDetail(JSON.stringify(staff_detail))
  },
  SET_DEF_STAFF_ROLE_ID: (state, staff_role_id) => {
    session.set('def_staff_role_id', staff_role_id)
    state.def_staff_role_id = staff_role_id
  },
  SET_STAFF_ROLE_LIST: (state, staff_role_list) => {
    session.setObject('staff_role_list', staff_role_list)
    state.staff_role_list = staff_role_list
  }
}

const actions = {
  setToken({ state, commit }, token) {
    commit('SET_TOKEN', token)
  },
  setStaffDetail({ state, commit }, staff_detail) {
    commit('SET_TOKEN', staff_detail)
  },
  async login({ state, commit, dispatch }, data) {
    try {
      const res = await login(data)
      const { staff_access_info } = res.data.data
      const token = staff_access_info.token
      dispatch('setToken', token)
      return res.data.data
    } catch (error) {
      error.message && Notify({ type: 'danger', message: error.message })
      dispatch('setToken', '')
      throw error
    }
  },
  async wxLogin({ state, commit, dispatch }, data) {
    try {
      const { staff_access_info } = await dispatch('weixin/deliveryWxLogin', data, { root: true })
      const token = staff_access_info.token
      await dispatch('setToken', token)
      return token
    } catch (error) {
      error.message && Notify({ type: 'danger', message: error.message })
      dispatch('setToken', '')
      throw error
    }
  },
  getStaffRole({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getStaffRole(data).then(response => {
        if (response.data.data.staff_role_List.length) {
          commit('SET_STAFF_ROLE_LIST', response.data.data.staff_role_List)
        }
        if (!state.def_staff_role_id && response.data.data.staff_role_List.length) {
          commit('SET_DEF_STAFF_ROLE_ID', response.data.data.staff_role_List[0].staff_role_id)
        }
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getStaffDetail({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getStaffDetail(data).then(response => {
        commit('SET_STAFF_DETAIL', response.data.data.staff_info)
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取群客户信息
  getManagerBusinessCount({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getManagerBusinessCount(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 01-获取门店列表
  getStoreList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getStoreList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // S-01-获取消息列表
  getMessageList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getMessageList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 综合数据分析
  getIntegratedAnalysis({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getIntegratedAnalysis(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // A-01-业绩数据分析
  getPerformanceAnalysis({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getPerformanceAnalysis(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 03-切换当前门店
  changeStore({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      changeStore(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 用户下订周期
  getOrderPeriodAnalysis({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getOrderPeriodAnalysis(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 读消息
  readMessageInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      readMessageInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // S-05-更新消息为已读状态
  updateMessageStatus({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      updateMessageStatus(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // G-02-流程订单列表
  getProcessOrderList(temp, data) {
    return new Promise((resolve, reject) => {
      getProcessOrderList(data).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // B-14-获取服务岗位员工列表
  getStationStaffList(temp, data) {
    return new Promise((resolve, reject) => {
      getStationStaffList(data).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getRolesStaffList(temp, data) {
    return new Promise((resolve, reject) => {
      getRolesStaffList(data).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // G-03-订单转设计师详情
  getDesigner(temp, data) {
    return new Promise((resolve, reject) => {
      getDesigner(data).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 12-获取小区
  getVillageList(temp, data) {
    return new Promise((resolve, reject) => {
      getVillageList(data).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // G-0301-订单转设计师提交
  saveDesigner(temp, data) {
    return new Promise((resolve, reject) => {
      saveDesigner(data).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // O-01-到店确认列表
  preCustomerList(temp, data) {
    return new Promise((resolve, reject) => {
      preCustomerList(data).then(response => {
        const data = response.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getAllList(temp, data) {
    return new Promise((resolve, reject) => {
      getAllList(data).then(response => {
        const data = response.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 17-获取预上门客户信息
  getPreCustomerInfo(temp, data) {
    return new Promise((resolve, reject) => {
      getPreCustomerInfo(data).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 01-创建销售机会
  saveOpportunity(temp, data) {
    return new Promise((resolve, reject) => {
      saveOpportunity(data).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 04-获取选项字段选择下拉列表
  getSelectFieldOption(temp, data) {
    return new Promise((resolve, reject) => {
      getSelectFieldOption(data).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 09-获取房屋类型
  getHouseTypeList(temp, data) {
    return new Promise((resolve, reject) => {
      getHouseTypeList(data).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 10-获取房屋状态类型
  getHouseStatusList(temp, data) {
    return new Promise((resolve, reject) => {
      getHouseStatusList(data).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 10-获取房屋状态类型
  getOfflineChannel(temp, data) {
    return new Promise((resolve, reject) => {
      getOfflineChannel(data).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // G-0806-查询当前门店下手机号是否已经下订
  QueryMobile({ commit }, data) {
    return new Promise((resolve, reject) => {
      QueryMobile(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getOpportunityList(temp, data) {
    return new Promise((resolve, reject) => {
      getOpportunityList(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // G-1102-获取订单订金单详情
  getOrderDepositInfo(temp, data) {
    return new Promise((resolve, reject) => {
      getOrderDepositInfo(data).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // G-1103-订单转大定提交(新)
  changeToBigDeposit(temp, data) {
    return new Promise((resolve, reject) => {
      changeToBigDeposit(data).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // G-1104-订单重新收款
  resetReceipt(temp, data) {
    return new Promise((resolve, reject) => {
      resetReceipt(data).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // B-15-获取门店产品包分类
  getStorePackageCategory(temp, data) {
    return new Promise((resolve, reject) => {
      getStorePackageCategory(data).then(response => {
        const { category_list } = response.data.data
        resolve(category_list)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // B-16-获取门店包列表
  getStoreProductPackage(temp, data) {
    return new Promise((resolve, reject) => {
      getStoreProductPackage(data).then(response => {
        const { product_package_list } = response.data.data
        resolve(product_package_list)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 下订详情
  getOrderDetails(temp, data) {
    return new Promise((resolve, reject) => {
      getOrderDetails(data).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 下订详情
  getOrder(temp, data) {
    return new Promise((resolve, reject) => {
      getOrder(data).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 下订
  saveOrder(temp, data) {
    return new Promise((resolve, reject) => {
      saveOrder(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 快速下订
  quickOrder(temp, data) {
    return new Promise((resolve, reject) => {
      quickOrder(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 用支付序号查询支付信息
  getOrderAmountInfoById({ commit }, data) {
    return new Promise((resolve, reject) => {
      getOrderAmountInfoById(data).then(response => {
        // const { opportunity_list } = response.data.data
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  buildCode({ commit }, data) {
    return new Promise((resolve, reject) => {
      buildCode(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 发送付款码
  sendAmountImage({ commit }, data) {
    return new Promise((resolve, reject) => {
      sendAmountImage(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  authent({ commit }, data) {
    return new Promise((resolve, reject) => {
      authent(data).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getFollowTypeList(temp, data) {
    return new Promise((resolve, reject) => {
      getFollowTypeList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // authent({ commit }, data) {
  //   return new Promise((resolve, reject) => {
  //     authent(data).then(response => {
  //       const data = response.data.data
  //       resolve(data)
  //     }).catch(error => {
  //       reject(error)
  //     })
  //   })
  // },
  receiptAmount({ commit }, data) {
    return new Promise((resolve, reject) => {
      receiptAmount(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // authent({ commit }, data) {
  //   return new Promise((resolve, reject) => {
  //     authent(data).then(response => {
  //       const data = response.data.data
  //       resolve(data)
  //     }).catch(error => {
  //       reject(error)
  //     })
  //   })
  // },
  saveOpportunityFollow(temp, data) {
    return new Promise((resolve, reject) => {
      saveOpportunityFollow(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getOrderList(temp, data) {
    return new Promise((resolve, reject) => {
      getOrderList(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveRefundAmount(temp, data) {
    return new Promise((resolve, reject) => {
      saveRefundAmount(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getChangeItems({ commit }, data) {
    return new Promise((resolve, reject) => {
      getChangeItems(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  appletWeChatCode(temp, data) {
    return new Promise((resolve, reject) => {
      appletWeChatCode(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getOrderStatus(temp, data) {
    return new Promise((resolve, reject) => {
      getOrderStatus(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getOrderDepositList(temp, data) {
    return new Promise((resolve, reject) => {
      getOrderDepositList(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getBroadcastAnalysis(temp, data) {
    return new Promise((resolve, reject) => {
      getBroadcastAnalysis(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // CM-03-需求录入确认
  confirm(temp, data) {
    return new Promise((resolve, reject) => {
      confirm(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // CM-01-初步需求评估列表
  getDemandsList(temp, data) {
    return new Promise((resolve, reject) => {
      getDemandsList(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  customerInfo(temp, data) {
    return new Promise((resolve, reject) => {
      customerInfo(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 27-设计服务空间列表
  getSpaceList(temp, data) {
    return new Promise((resolve, reject) => {
      getSpaceList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getMembers(temp, data) {
    return new Promise((resolve, reject) => {
      getMembers(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getCharacterTrend(temp, data) {
    return new Promise((resolve, reject) => {
      getCharacterTrend(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getMeasureInviteList(temp, data) {
    return new Promise((resolve, reject) => {
      getMeasureInviteList(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getMetering(temp, data) {
    return new Promise((resolve, reject) => {
      getMetering(data).then(response => {
        resolve(response.data.data.house_info)
      }).catch(error => {
        reject(error)
      })
    })
  },
  addInvite(temp, data) {
    return new Promise((resolve, reject) => {
      addInvite(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getMeasureInvite(temp, data) {
    return new Promise((resolve, reject) => {
      getMeasureInvite(data).then(response => {
        resolve(response.data.data.measure_info)
      }).catch(error => {
        reject(error)
      })
    })
  },
  determineMeasure(temp, data) {
    return new Promise((resolve, reject) => {
      determineMeasure(data).then(response => {
        resolve(response.data.status)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // CM-05-修改协作
  editDesigner(temp, data) {
    return new Promise((resolve, reject) => {
      editDesigner(data).then(response => {
        resolve(response.data.measure_info)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // A-11-(rad1)创建需求邀请
  addDemandInvite(temp, data) {
    return new Promise((resolve, reject) => {
      addDemandInvite(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // A-10-(rad1)初步需求邀请列表
  getDemandInviteList(temp, data) {
    return new Promise((resolve, reject) => {
      getDemandInviteList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // (rad1)-06-邀请涵详情
  getInviteInfo(temp, data) {
    return new Promise((resolve, reject) => {
      getInviteInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  delInvite(temp, data) {
    return new Promise((resolve, reject) => {
      delInvite(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // A-13-查看是否完成需求确认
  getOpportunityAffirmStatus(temp, data) {
    return new Promise((resolve, reject) => {
      getOpportunityAffirmStatus(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getOpportunityLoseReason(temp, data) {
    return new Promise((resolve, reject) => {
      getOpportunityLoseReason(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  loseOpportunity(temp, data) {
    return new Promise((resolve, reject) => {
      loseOpportunity(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // CM-01-关键数据统计
  keyDataStatistics(temp, data) {
    return new Promise((resolve, reject) => {
      keyDataStatistics(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // CM-02-面谈量统计
  interviewStatistics(temp, data) {
    return new Promise((resolve, reject) => {
      interviewStatistics(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // CM-03-关键动作统计
  keyActionStatistics(temp, data) {
    return new Promise((resolve, reject) => {
      keyActionStatistics(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // CM-04-上门订单类型统计
  orderTypeStatistics(temp, data) {
    return new Promise((resolve, reject) => {
      orderTypeStatistics(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // CM-05-上门接待时长统计
  timeStatistics(temp, data) {
    return new Promise((resolve, reject) => {
      timeStatistics(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // CM-08-门店客户经理列表
  managerList(temp, data) {
    return new Promise((resolve, reject) => {
      managerList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 讲解
  getExplainCustomer(temp, data) {
    return new Promise((resolve, reject) => {
      getExplainCustomer(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 07-离店
  getOverStoreInfo(temp, data) {
    return new Promise((resolve, reject) => {
      getOverStoreInfo(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // CM-07-离店提醒内容
  leaveNoticeMessage(temp, data) {
    return new Promise((resolve, reject) => {
      leaveNoticeMessage(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 02-获取门店信息
  getStoreDetail(temp, data) {
    return new Promise((resolve, reject) => {
      getStoreDetail(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // H-02-获取订单相关基础信息
  getOrderInfo(temp, data) {
    return new Promise((resolve, reject) => {
      getOrderInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // (新)CM-01-用户下订
  getCustomers(temp, data) {
    return new Promise((resolve, reject) => {
      getCustomers(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // (新)CM-02-跟进用户列表
  getFollowList({ commit }, data) {
    return new Promise((resolve, reject) => {
      getFollowList(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // (新)CM-03-今日需跟进列表
  getTodayFollowList(temp, data) {
    return new Promise((resolve, reject) => {
      getTodayFollowList(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // (新)CM-04-待转设计师列表
  getDesignedList(temp, data) {
    return new Promise((resolve, reject) => {
      getDesignedList(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // (新)CM-05-标记无效上门
  invalidVisit(temp, data) {
    return new Promise((resolve, reject) => {
      invalidVisit(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // (新)CM-06-订单列表
  getOrderListContinue(temp, data) {
    return new Promise((resolve, reject) => {
      getOrderListContinue(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 16-预上门客户未到店
  noVisit(temp, data) {
    return new Promise((resolve, reject) => {
      noVisit(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 16-预上门客户未到店
  getOrderAmountList(temp, data) {
    return new Promise((resolve, reject) => {
      getOrderAmountList(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // (新)CM-06-获取门店店长
  getStoreManager(temp, data) {
    return new Promise((resolve, reject) => {
      getStoreManager(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // (新)CM-06-创建预售合同提交
  savePresaleContract(temp, data) {
    return new Promise((resolve, reject) => {
      savePresaleContract(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // (新)CM-08跟进用户详情
  getFollowDetail(temp, data) {
    return new Promise((resolve, reject) => {
      getFollowDetail(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // M-获取收款单详情
  getOrderAmountInfo(temp, data) {
    return new Promise((resolve, reject) => {
      getOrderAmountInfo(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // M-关闭收款单
  closeAmount(temp, data) {
    return new Promise((resolve, reject) => {
      closeAmount(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // G-9001-订单详情-基本信息
  getBaseOrderDetail(temp, data) {
    return new Promise((resolve, reject) => {
      getBaseOrderDetail(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 28-发送验证码
  sendSmsCode(temp, data) {
    return new Promise((resolve, reject) => {
      sendSmsCode(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 03-获取退款单详情
  getRefundAmountInfo(temp, data) {
    return new Promise((resolve, reject) => {
      getRefundAmountInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 2-发起审批
  saveApprovalInfo({ commit }, pageData) {
    return new Promise((resolve, reject) => {
      saveApprovalInfo(pageData).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  savePresaleOrder({ commit }, pageData) {
    return new Promise((resolve, reject) => {
      savePresaleOrder(pageData).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getBaseOpportunityInfo({ commit }, pageData) {
    return new Promise((resolve, reject) => {
      getBaseOpportunityInfo(pageData).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 10-获取房屋信息
  getHouseInfo({ commit }, pageData) {
    return new Promise((resolve, reject) => {
      getHouseInfo(pageData).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  changeToPresale({ commit }, pageData) {
    return new Promise((resolve, reject) => {
      changeToPresale(pageData).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // (新)CM-10-用户列表
  getCustomerList({ commit }, pageData) {
    return new Promise((resolve, reject) => {
      getCustomerList(pageData).then(response => {
        const data = response.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // G-1103-签预售
  savePreSale({ commit }, pageData) {
    return new Promise((resolve, reject) => {
      savePreSale(pageData).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getOpportunityStatus({ commit }, pageData) {
    return new Promise((resolve, reject) => {
      getOpportunityStatus(pageData).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getLoseReasonList({ commit }, pageData) {
    return new Promise((resolve, reject) => {
      getLoseReasonList(pageData).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getMayRefundAmount({ commit }, pageData) {
    return new Promise((resolve, reject) => {
      getMayRefundAmount(pageData).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getOpportunityFollowHistory({ commit }, pageData) {
    return new Promise((resolve, reject) => {
      getOpportunityFollowHistory(pageData).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getFollowProcessList({ commit }, pageData) {
    return new Promise((resolve, reject) => {
      getFollowProcessList(pageData).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getFollowDesignerList({ commit }, pageData) {
    return new Promise((resolve, reject) => {
      getFollowDesignerList(pageData).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getFollowRecord({ commit }, pageData) {
    return new Promise((resolve, reject) => {
      getFollowRecord(pageData).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getFollowProcessDesignerList({ commit }, pageData) {
    return new Promise((resolve, reject) => {
      getFollowProcessDesignerList(pageData).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  addDesignerFollow({ commit }, pageData) {
    return new Promise((resolve, reject) => {
      addDesignerFollow(pageData).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getPersonalDemand({ commit }, pageData) {
    return new Promise((resolve, reject) => {
      getPersonalDemand(pageData).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getSelectOperation({ commit }, pageData) {
    return new Promise((resolve, reject) => {
      getSelectOperation(pageData).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
